export const handleStickyHeader = targetRef => () => {
  const { current } = targetRef;

  if (current) {
    const allocationSection = current;

    const ALLOCATION_HEADER_OFFSET =
      document.getElementsByClassName('navbar')[0].offsetHeight +
      document.getElementById('build-portfolio-header').offsetHeight;

    allocationSection.classList[
      window.scrollY <= ALLOCATION_HEADER_OFFSET ? 'remove' : 'add'
    ]('fixed');
  }
};
